import React from 'react';
import {useBreakpoint} from "../../../libs/breakpoint";
import './_Adverising.scss';
import {useQueryClient} from "@tanstack/react-query";
import {USER_CURRENT_KEY} from "../../../api/public-voissa/users";
import _ from "lodash";


const advertisingList = {
    //'300x100' : <iframe title="tool" width="300" height="100" src="https://tools.emstat.fr/voissa/300x100.php" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no" className={"h-100"}></iframe>
}

const AdvertisingShow = ({
         sizeMobile = "0x0",
         sizeTable = "0x0",
         sizeDesktop = "0x0",
         className = ""
     }) => {

    const breakpoints = useBreakpoint();
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";
    let size = "0x0";

    if (breakpoints.sm) {
        size = sizeMobile;
    } else if (breakpoints.md) {
        size = sizeTable;
    }
    else{
        size = sizeDesktop;
    }

    return ["", "voissa"].includes(source) && advertisingList[size] ? (
        <div className={`advertising ${className}`}>
            {advertisingList[size]}
        </div>
    ) : null;
}

const Advertising = ({
        sizeMobile = "0x0",
        sizeTable = "0x0",
        sizeDesktop = "0x0",
        className = ""
    }) => {
    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');
    return !isCurrentUser ? (
        <AdvertisingShow sizeMobile={sizeMobile} sizeTable={sizeTable} sizeDesktop={sizeDesktop} className={className} />
    ) : null;
}

export default Advertising;
